import permCode from '@/config/permCode'
export default [
  {
    permission: '@',
    title: "我的考勤",
    sortOrder: 8,
    icon: "el-icon-menu",
    url: "https://attendance.console.huonu.com/dashboard",
  },
  {
    permission: '@',
    title: "合同工作台",
    sortOrder: 8,
    icon: "el-icon-menu",
    url: "https://cw-workbench.console.huonu.com",
  },
  {
    permission: permCode.ROSTER_LIST,
    title: '花名册',
    sortOrder: 9,
    icon: 'el-icon-menu',
    url: '/roster/index'
  }
]
